<template>
  <div
    class="hidden xl:block w-full lg:max-w-80 lg:min-w-56"
  >
    <div class="lg:sticky lg:top-24">
      <div class="bg-white border lg:rounded shadow-sm pb-8">
        <h3 class="!text-gray-900 font-medium p-3 border-b border-b-gray-100">
          Document Index
        </h3>

        <ul>
          <template
            v-for="(title, index) in pageTitles"
            :key="index"
          >
            <li
              class="px-4 py-2.5 cursor-pointer hover:bg-gray-50 duration-150 transition-colors text-xs xl:text-sm"
              :class="{ 'bg-slate-200 font-medium text-gray-900 hover:bg-slate-200': page === index }"
              @click="handleIndexClick(index)"
            >
              {{ title }}
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  pageTitles: {
    type: Array,
    default: () => [],
  },
});

const page = defineModel({ type: Number, default: 0 });

const handleIndexClick = index => {
  page.value = index;

  window.scrollTo(0, 0);
};
</script>
